export default __webpack_public_path__ + "static/media/Memories.e9912716.mp3";